<template>
    <div class="main">
        <header class="g-hd f-bcf">
            <img class="back" @click="backward()" src="../../assets/jxwx/report/arr_02.png" alt="">
            <div class="f-dfsb">
                {{data.departMentName}}
                <span class="time">{{time}}</span>
            </div>
        </header>
        <van-tabs>
            <van-tab title="门诊">
                <div class="u-card cardBox">
                    <div class="bd">
                        <div class="m-hos" v-if="data.townouthosquota == 0">
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.townouthosprop <= 80,'progress_bar3':data.townouthosprop >= 100}" :style="{width: data.townouthosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.townouthosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">--</span>
                            </div>
                        </div>
                        <div class="m-hos" v-else>
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.townouthosprop <= 80,'progress_bar3':data.townouthosprop >= 100}" :style="{width: data.townouthosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">{{data.townouthosprop}}%</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">{{data.townouthosquota | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.townouthosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">{{data.townouthossurplus | moneyP}}</span>
                            </div>
                        </div>
                        <div class="m-hos" v-if="data.resouthosquota == 0">
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室居民医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.resouthosprop <= 80,'progress_bar3':data.resouthosprop >= 100}" :style="{width: data.resouthosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.resouthosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">--</span>
                            </div>
                        </div>
                        <div class="m-hos" v-else>
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室居民医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.resouthosprop <= 80,'progress_bar3':data.resouthosprop >= 100}" :style="{width: data.resouthosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">{{data.resouthosprop}}%</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">{{data.resouthosquota | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.resouthosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">{{data.resouthossurplus | moneyP}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="f-bc">
                    <div class="u-card cardBox" v-for="item in data.medicalEntity" :key="item.id" @click="toGroupDetails(item)">
                        <div class="hd">
                            <img class="icon" src="../../assets/jxwx/report/icon_04.png" alt="">
                            <div class="tt">
                                <span>{{item.clinicmergedesc}}</span>
                                <!-- <span>{{item.groupleader_name | nameP}}</span> -->
                            </div>
                            <img class="arr" src="../../assets/jxwx/arr_05.png" alt="">
                        </div>
                        <div class="bd">
                            <div class="lf">
                                <div class="tt">当前城镇医保均次</div>
                                <div class="num">{{item.townouthosavg | moneyP}}</div>
                            </div>
                            <div class="rg">
                                <div class="tt">当前居民医保均次</div>
                                <div class="num">{{item.resouthosavg | moneyP}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="住院">
                <div class="u-card cardBox">
                    <div class="bd">
                        <div class="m-hos" v-if="data.towninhosquota == 0">
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.towninhosprop <= 80,'progress_bar3':data.towninhosprop >= 100}" :style="{width: data.towninhosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.towninhosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">--</span>
                            </div>
                        </div>
                        <div class="m-hos" v-else>
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室城镇医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.towninhosprop <= 80,'progress_bar3':data.towninhosprop >= 100}" :style="{width: data.towninhosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">{{data.towninhosprop}}%</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">{{data.towninhosquota | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.towninhosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">{{data.towninhossurplus | moneyP}}</span>
                            </div>
                        </div>
                        <div class="m-hos" v-if="data.resinhosquota == 0">
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室居民医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.resinhosprop <= 80,'progress_bar3':data.resinhosprop >= 100}" :style="{width: data.resinhosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">--</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.resinhosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">--</span>
                            </div>
                        </div>
                        <div class="m-hos" v-else>
                            <header class="f-df">
                                <img src="../../assets/jxwx/report/point.png" alt=""> 科室居民医保
                            </header>
                            <div class="progress">
                                <div class="progress_bar" :class="{'progress_bar2':data.resinhosprop <= 80,'progress_bar3':data.resinhosprop >= 100}" :style="{width: data.resinhosprop + '%'}">
                                </div>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次占比</span>
                                <span class="mark nm">{{data.resinhosprop}}%</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次额度</span>
                                <span class="nm">{{data.resinhosquota | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">当前医保均次</span>
                                <span class="nm">{{data.resinhosavg | moneyP}}</span>
                            </div>
                            <div class="entry">
                                <span class="ctt">医保均次剩余</span>
                                <span class="mark nm">{{data.resinhossurplus | moneyP}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="f-bc">
                    <div class="u-card cardBox" v-for="item in data.medicalEntity" :key="item.id" @click="toGroupDetails(item)">
                        <div class="hd">
                            <img class="icon" src="../../assets/jxwx/report/icon_04.png" alt="">
                            <div class="tt">
                                <span>{{item.clinicmergedesc}}</span>
                                <!-- <span>{{item.groupleader_name | nameP}}</span> -->
                            </div>
                            <img class="arr" src="../../assets/jxwx/arr_05.png" alt="">
                        </div>
                        <div class="bd">
                            <div class="lf">
                                <div class="tt">当前城镇医保均次</div>
                                <div class="num">{{item.towninhosavg | moneyP}}</div>
                            </div>
                            <div class="rg">
                                <div class="tt">当前居民医保均次</div>
                                <div class="num">{{item.resinhosavg | moneyP}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
        </van-tabs>

    </div>
</template>

<script>
import api from "@/axios/api";
export default {
    data() {
        return {
            time: this.$route.query.time,
            data: this.$route.query.data
        };
    },
    mounted() {},
    methods: {
        backward() {
            
            this.$router.backward();
            // alert(this.$route.params.isBack)
        },

        toGroupDetails(item){
            this.$router.replace({
                path: "/jxwx/groupDetails",
                query: {
                    data:item,
                    time:this.time
                }
            });
        }

        // getDailyCountData() {
        //     let params = {
        //         date: this.time
        //     };
        //     api.getDailyCountData(params).then(res => {
        //         this.countData = res;
        //     });
        // },
    }
};
</script>

<style lang="less" scoped>
.g-hd {
    display: flex;
    align-items: center;
    height: 13.3vw;
    padding: 0 3.3vw;
    color: #fff;
    background: #5584ff;
    .f-dfsb {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .back {
        width: 2vw;
        font-size: 16px;
        margin-right: 2.6vw;
    }
    .time {
        font-size: 12px;
    }
    .tt {
        margin-left: 4vw;
    }
}
.main {
    /deep/.van-tabs {
        margin-top: 2.6vw;
        background: #fff;
        .van-tabs__wrap {
            border-bottom: 1px solid#E0DFDF;
        }
        .van-tab--active {
            color: #5584ff;
        }
        .van-tabs__line {
            width: 16vw !important;
            background-color: #5584ff;
        }
    }
}

.u-card {
    margin: 2.6vw 4vw 0 4vw;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    // border-radius: 6px;
}
.cardBox {
    .hd {
        display: flex;
        font-size: 13px;
        justify-content: space-between;
        align-items: center;
        height: 12vw;
        padding: 0 4vw;
        border-bottom: 1px solid #dedede;
        .icon {
            width: 4vw;
        }
        .tt {
            display: flex;
            align-items: center;
            img {
                margin-right: 1.6vw;
            }
        }
        .arr {
            width: 1.3vw;
        }
    }
    .bd {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 2vw 0 1.4vw 0;
        .m-hos {
            width: 50%;
            padding: 0 2vw;
            box-sizing: border-box;
            .f-df {
                display: flex;
                align-items: center;
            }
        }
        // .m-hos2 {
        //     width: 42vw;
        //     padding: 0 ;
        // }
        .m-hos header {
            margin-bottom: 3.4667vw;
            font-size: 14px;
            color: #4c4c4c;
        }
        .m-hos header img {
            width: 1.3333vw;
            margin-right: 1.3333vw;
        }
        .m-hos .progress {
            width: 100%;
            height: 2.1333vw;
            margin-bottom: 2.6667vw;
            border-radius: 1.0667vw;
            background-color: #efefef;
            overflow: hidden;
            .progress_bar {
                height: 100%;
                background-color: #fed100;
            }
            .progress_bar2 {
                height: 100%;
                background-color: #91C619;
            }
            .progress_bar3 {
                height: 100%;
                background-color: #F66969;
            }
        }

        .m-hos .entry {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 3.2vw;
            font-size: 12px;
        }
        .m-hos > .entry > .ctt {
            color: #8f8f8f;
        }
        .m-hos > .entry > .nm {
            font-size: 13px;
            color: #282828;
        }
        .m-hos > .entry > .mark {
            color: #f66969;
            background: #fff;
        }
        .m-hos > .entry > .mark2 {
            color: #91c619;
        }
    }
}
.f-bc {
    padding: 2.6vw 0;
    background: #f7f7f7;
    .u-card {
        margin: 2.6vw 4vw;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
        border-radius: 6px;
    }
    .cardBox {
        .hd {
            display: flex;
            font-size: 13px;
            justify-content: start;
            align-items: center;
            height: 12vw;
            padding: 0 4vw;
            border-bottom: 1px solid #dedede;
            .icon {
                width: 4vw;
            }
            .tt {
                display: flex;
                justify-content: space-between;
                width: 45vw;
                margin: 0 3.2vw 0 1.6vw;
            }
            .arr {
                width: 1.3vw;
            }
        }
        .bd {
            display: flex;
            justify-content: space-between;
            padding: 4vw;
            .tt {
                margin-bottom: 3.2vw;
                font-size: 13px;
                color: #a6a6a6;
            }
            .num {
                font-size: 18px;
            }
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/jxwx/components/depDetails.vue